var _defs, _path, _path2, _rect, _path3, _path4, _path5, _polyline, _polyline2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa427600-ab71-4ff9-8df9-0dbd2e83703e",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a6a3a712-16ce-4770-bacb-f3409bbc5213,.b6ed2c09-fb2b-4c48-81b4-1110f7865e87{fill:none;}.b6ed2c09-fb2b-4c48-81b4-1110f7865e87,.e8b2d097-1fa2-4b4e-a49d-58a041f8266b{stroke:#8e8e8e;}.a6a3a712-16ce-4770-bacb-f3409bbc5213,.b6ed2c09-fb2b-4c48-81b4-1110f7865e87,.e8b2d097-1fa2-4b4e-a49d-58a041f8266b{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b1aaaf37-e234-4bd0-8624-f0d8a762ec9d,.e8b2d097-1fa2-4b4e-a49d-58a041f8266b{fill:#68b21d;}.f43efb5c-8d0a-410a-b050-81623f69496f{fill:#fff;}.a6a3a712-16ce-4770-bacb-f3409bbc5213{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gif") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b6ed2c09-fb2b-4c48-81b4-1110f7865e87",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e8b2d097-1fa2-4b4e-a49d-58a041f8266b",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b1aaaf37-e234-4bd0-8624-f0d8a762ec9d",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f43efb5c-8d0a-410a-b050-81623f69496f",
    d: "M53.3,71.9a9.9,9.9,0,0,1-3.1.5,5.5,5.5,0,0,1-3.8-1.3A5.5,5.5,0,0,1,45,67.3a5.1,5.1,0,0,1,5.5-5.2,5.9,5.9,0,0,1,2.5.5l-.3,1a5.7,5.7,0,0,0-2.2-.4,3.8,3.8,0,0,0-4.1,4.1,3.7,3.7,0,0,0,3.9,4,5.4,5.4,0,0,0,1.7-.2v-3H50V67h3.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f43efb5c-8d0a-410a-b050-81623f69496f",
    d: "M56.6,62.2V72.3H55.3V62.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f43efb5c-8d0a-410a-b050-81623f69496f",
    d: "M58.9,62.2h5.4v1.1H60.2v3.4H64v1.1H60.2v4.5H58.9Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a6a3a712-16ce-4770-bacb-f3409bbc5213",
    points: "37.1 24.3 63.2 24.3 63.2 53.5 30.6 53.5 30.6 32.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a6a3a712-16ce-4770-bacb-f3409bbc5213",
    points: "31.1 53.5 42.7 41.9 53.9 53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a6a3a712-16ce-4770-bacb-f3409bbc5213",
    x1: 48,
    y1: 47.1,
    x2: 62.6,
    y2: 32.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a6a3a712-16ce-4770-bacb-f3409bbc5213",
    cx: 48,
    cy: 33.8,
    r: 3.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.d0650885d21f42bfba1fad471ff257bc.svg";
export { ForwardRef as ReactComponent };